import API from '@/views/Fdc/Apis/'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1.

/**
 * Real Time > EQP Status Monitor
 * 실시간 장비 상태 확인 (RUN, IDLE, UNKNOWN)
 */
export default {
  name: 'EqpStatusMonitor',
  beforeMount () {
    this.initColumns()
  },
  methods: {
    /**
     * Grid Column initialize
     */
    initColumns () {
      let self = this

      // STATUS 표시 rule 지정
      const statusCellClassRules = {
        'status status-run': (params) => params.value === 'RUN',
        'status status-idle': (params) => params.value === 'IDLE',
        'status status-down': (params) => params.value === 'DOWN',
        'status status-unknown': (params) => params.value === 'UNKNOWN'
      }
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.STATUS'), field: 'status', width: 100, cellClassRules: statusCellClassRules },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.BATCH_ID'), field: 'batchId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.OPER_ID'), field: 'operId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), field: 'reticleId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_TYPE'), field: 'lotType', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PPID'), field: 'ppId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LAYER'), field: 'layer', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.DEVICE'), field: 'device', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ETC_INFO'), field: 'etcInfo', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CREATE_DATE'), field: 'createDate', width: 200 },
        {
          headerName: this.$t('fdc.COMMON.COLUMN.MONITOR'),
          field: 'monitor',
          width: 100,
          cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            clicked: function (params) {
              self.openRealTimeMonitor(params)
            }, // button click event 설정
            btnType: 'is-light',
            btnIcon: 'chart-line', // button icon 설정
            btnTitle: 'Real Time Monitor' // button title 설정
            // btnStyle: 'height: 20px;' // button 추가 style 설정
            // btnLabel: 'Monitor' // button text 설정
          }
        }
      ]
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.fabList = []
      this.eqpList = []
      this.moduleList = []
      this.stateData = []

      this.selectedTreeNode = node

      if (node.detail.moduleId === '') {
        this.parseArr(node)
      } else {
        this.fabList.push(node.detail.fab)
        this.eqpList.push(node.detail.eqpId)
        this.moduleList.push(node.detail.moduleId)
      }
      this.displayEqpStatus()

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )
    },
    /**
     * node data parsing
     * @param {Object} node EQP tree node data
     * 각 노드의 children을 탐색하여 fab, eqpId. moduleId정보를 구합니다.
     */
    parseArr (node) {
      if (node.hasOwnProperty('children')) {
        node.children.forEach((node) => {
          if (node.detail.moduleId !== '') {
            this.fabList.push(node.detail.fab)
            this.eqpList.push(node.detail.eqpId)
            this.moduleList.push(node.detail.moduleId)
          }
          return this.parseArr(node)
        })
      }
    },
    /**
     * Real Time Monitor 연동
     * @param {*} params BRIQUE Grid row params
     */
    openRealTimeMonitor (params) {
      const item = params.data
      if (!_.isEmpty(item.fab) && !_.isEmpty(item.eqpId) && !_.isEmpty(item.moduleId)) {
        let routeData = this.$router.resolve({
          name: 'realtime-monitor',
          query: {
            fab: item.fab,
            eqpId: item.eqpId,
            moduleId: item.moduleId
          }
        })
        window.open(routeData.href, '_blank')
      }
    },
    /**
     * EQP Status Monitor 재조회
     */
    refreshEqpStatus () {
      this.displayEqpStatus()
    },
    /**
     * EQP Status Monitor 조회
     */
    async displayEqpStatus () {
      try {
        let response = await API.Monitor.getEqpsStatus([...this.fabList], [...this.eqpList], [...this.moduleList])
        // console.log(response);
        response = response.filter((data) => {
          if (data !== null) {
            return true
          }
        })

        let obj = {}
        if (this.selectedTreeNode.detail.moduleId !== '') {
          obj.fab = this.selectedTreeNode.detail.fab
          obj.line = this.selectedTreeNode.detail.line
          obj.area = this.selectedTreeNode.detail.area
          obj.eqpModel = this.selectedTreeNode.detail.eqpModel
          obj.eqpId = this.selectedTreeNode.detail.eqpId
          obj.moduleId = this.selectedTreeNode.detail.moduleId
        }

        if (this.selectedTreeNode.detail.eqpId !== '') {
          obj.fab = this.selectedTreeNode.detail.fab
          obj.line = this.selectedTreeNode.detail.line
          obj.area = this.selectedTreeNode.detail.area
          obj.eqpModel = this.selectedTreeNode.detail.eqpModel
          obj.eqpId = this.selectedTreeNode.detail.eqpId
        }

        if (this.selectedTreeNode.detail.eqpModel !== '') {
          obj.fab = this.selectedTreeNode.detail.fab
          obj.line = this.selectedTreeNode.detail.line
          obj.area = this.selectedTreeNode.detail.area
          obj.eqpModel = this.selectedTreeNode.detail.eqpModel
        }

        if (this.selectedTreeNode.detail.area !== '') {
          obj.fab = this.selectedTreeNode.detail.fab
          obj.line = this.selectedTreeNode.detail.line
          obj.area = this.selectedTreeNode.detail.area
        }

        if (this.selectedTreeNode.detail.line !== '') {
          obj.fab = this.selectedTreeNode.detail.fab
          obj.line = this.selectedTreeNode.detail.line
        }

        if (this.selectedTreeNode.detail.fab !== '') {
          obj.fab = this.selectedTreeNode.detail.fab
        }
        let eqpList = await API.BaseInfo.getEqps(obj)
        let temp = []
        eqpList.forEach(eqp => {
          this.statusObj.fab = eqp.fab
          this.statusObj.eqpId = eqp.eqpId
          this.statusObj.moduleId = eqp.moduleId
          this.statusObj.fabEqpIdModuleId = eqp.fab + eqp.eqpId + eqp.moduleId
          this.statusObj.status = 'UNKNOWN'

          temp.push({ ...this.statusObj })
        })

        this.stateData = [...temp]
        this.stateData.forEach(data => {
          response.forEach(res => {
            if (data.fab === res.fab &&
                  data.eqpId === res.eqpId &&
                    data.moduleId === res.moduleId
            ) {
              data.batchId = res.batchId
              data.carrId = res.carrId
              data.device = res.device
              data.etcInfo = res.etcInfo
              data.layer = res.layer
              data.lotId = res.lotId
              data.lotType = res.lotType
              data.moduleId = res.moduleId
              data.operId = res.operId
              data.ppId = res.ppId
              data.procId = res.procId
              data.prodId = res.prodId
              data.recipeId = res.recipeId
              data.slot = res.slot
              data.status = res.status
              data.substId = res.substId
              data.monitor = 'RUN'
            }
          })
        })
      } catch (error) {
        console.log(error)
      }
    }
  },
  data () {
    return {
      statusObj: {
        'batchId': '',
        'carrId': '',
        'createDate': '',
        'device': '',
        'eqpId': '',
        'etcInfo': '',
        'fab': '',
        'fabEqpIdModuleId': '',
        'layer': '',
        'lotId': '',
        'lotType': '',
        'moduleId': '',
        'operId': '',
        'ppId': '',
        'procId': '',
        'prodId': '',
        'recipeId': '',
        'reticleId': '',
        'slot': '',
        'status': '',
        'substId': ''
      }, // EQP Status Object 형태
      // treeNodes: [],
      // nodeIds: [],
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.STATUS'), binding: 'status', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), binding: 'carrId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.BATCH_ID'), binding: 'batchId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.OPER_ID'), binding: 'operId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROD_ID'), binding: 'prodId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), binding: 'reticleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_TYPE'), binding: 'lotType', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PPID'), binding: 'ppId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LAYER'), binding: 'layer', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.DEVICE'), binding: 'device', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.ETC_INFO'), binding: 'etcInfo', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CREATE_DATE'), binding: 'createDate', width: 200, readOnly: true },
      //   { label: '', binding: 'monitor', width: 100 }
      // ], // EQP Status Monitor grid column 배열
      columns: [], // EQP Status Monitor grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      stateData: [], // EQP Status Monitor row data
      fabList: [], // 선택된 Fab 목록 배열 (search condition)
      eqpList: [], // 선택된 EQP ID 목록 배열 (search condition)
      moduleList: [], // 선택된 Module ID 목록 배열 (search condition)
      selectedTreeNode: [], // 선택된 EQP Tree node
      frameworkComponents: {} // BRIQUE Grid framework components
    }
  }
}
